import UploadIcon from "@mui/icons-material/Upload";
import Button from "@mui/material/Button";
import React from "react";
import strings from "../../config/localization";

interface Props {
  onClickHandler?: () => void;
  label?: string;
  size?: "medium" | "small" | "large" | undefined;
  id?: string;
}

export default function UploadButton({
  onClickHandler = () => {},
  label = strings.upload,
  size = "medium",
  id = "exportButton",
}: Props) {
  return (
    <Button
      variant="outlined"
      size={size}
      id={id}
      startIcon={<UploadIcon />}
      onClick={onClickHandler}
    >
      {label}
    </Button>
  );
}
